document.addEventListener('DOMContentLoaded', () => {
  // --- Scroll Top Butonu Bölümü ---
  const scrollTopBtn = document.getElementById('scroll-top-btn');
  if (scrollTopBtn) {
    window.addEventListener('scroll', () => {
      scrollTopBtn.classList.toggle('show', window.scrollY > 300);
    });
    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // --- "Daha Fazla Yükle" Uygulaması ---
  const App = {
    isLoading: false,

    // YENİ VE BASİT URL FONKSİYONU: Sadece butondaki URL'ye güven.
    buildNextUrl: function(button) {
      return button?.dataset?.nextUrl || null;
    },

    loadMoreHandler: async function() {
      const loadMoreButton = document.getElementById('load-more');
      if (App.isLoading || !loadMoreButton) return;

      // fetchUrl artık section_id parametresi OLMADAN, temiz bir URL olacak.
      const fetchUrl = App.buildNextUrl(loadMoreButton);
      if (!fetchUrl) {
        if(loadMoreButton) loadMoreButton.closest('#load-more-container')?.remove();
        return;
      }
      
      App.isLoading = true;
      const originalText = loadMoreButton.textContent || 'Daha Fazla Yükle';
      loadMoreButton.disabled = true;
      loadMoreButton.textContent = 'Yükleniyor...';
      loadMoreButton.classList.add('loading');

      try {
        // Bir sonraki sayfanın TAMAMINI çekiyoruz.
        const response = await fetch(fetchUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const nextPage = parser.parseFromString(html, 'text/html');

        // Gelen yeni sayfanın içinden SADECE ürünleri ve yeni butonu alıyoruz.
        const newGridItems = nextPage.querySelectorAll('#product-grid > .grid__item');
        const newLoadMoreButton = nextPage.getElementById('load-more');
        const currentGrid = document.getElementById('product-grid');

        if (newGridItems.length > 0 && currentGrid) {
          // Gelen ürünleri doğrudan ekle. ARTIK slice veya akıllı mantık YOK.
          newGridItems.forEach(item => {
            currentGrid.appendChild(item);
          });
        }
        
        // Butonu güncelle veya kaldır.
        if (newLoadMoreButton && newLoadMoreButton.dataset.nextUrl) {
          loadMoreButton.dataset.nextUrl = newLoadMoreButton.dataset.nextUrl;
          loadMoreButton.disabled = false;
          loadMoreButton.textContent = originalText;
          loadMoreButton.classList.remove('loading');
        } else {
          loadMoreButton.closest('#load-more-container')?.remove();
        }
      } catch (error) {
        console.error('Hata:', error);
        if(loadMoreButton) {
          loadMoreButton.textContent = 'Hata! Tekrar Dene';
          loadMoreButton.disabled = false;
          loadMoreButton.classList.remove('loading');
        }
      } finally {
        App.isLoading = false;
      }
    },

    scrollHandler: function() {
      const loadMoreButton = document.getElementById('load-more');
      if (loadMoreButton && !App.isLoading) {
        const rect = loadMoreButton.getBoundingClientRect();
        if (rect.top < window.innerHeight + 400) {
          App.loadMoreHandler();
        }
      }
    },

    initButton: function() {
      const loadMoreButton = document.getElementById('load-more');
      if (!loadMoreButton) return;
      
      const newButton = loadMoreButton.cloneNode(true);
      loadMoreButton.parentNode.replaceChild(newButton, loadMoreButton);
      newButton.addEventListener('click', App.loadMoreHandler);
    }
  };

  // --- UYGULAMAYI BAŞLATAN BÖLÜM ---
  App.initButton();
  window.addEventListener('scroll', App.scrollHandler);

  // Filtreleme sonrası event listener'ı yenile
  document.addEventListener('shopify:section:load', function(event) {
      // Artık sectionId kontrolü daha basit olabilir veya tamamen kaldırılabilir,
      // ama güvenlik için bırakmakta fayda var.
      if (document.getElementById('ProductGridContainer')) {
        App.initButton();
      }
  });
});